import React from 'react';
import { useState } from 'react';
import './index.scss';
import { useNavigate } from 'react-router-dom';

type Tab = {
  label: string;
  key: string;
  content: React.ReactNode;
};

type TabCompProps = {
  tabs: Tab[];
  defaultSelectedTab: Tab;
  className?: string;
  route?: string;
};

const Tab = ({ tabs, defaultSelectedTab, className, route }: TabCompProps) => {
  const navigate = useNavigate();

  const [selectedTab, selectTab] = useState(defaultSelectedTab);
  const handleSelectedTab = (tab: Tab) => {
    selectTab(tab);
  };
  return (
    <div>
      <div className='tab_list'>
        {tabs.map((tab) => {
          return (
            <button
              key={tab.key}
              onClick={() => {
                handleSelectedTab(tab);
                if (route) {
                  navigate(`/${route}/${tab?.key}`);
                }
              }}
              className={
                className ??
                `tab-button 
             ${tab?.key === selectedTab?.key ? 'tab-button-selected' : 'tab-button-notSelected'}
             `
              }>
              {tab.label}
            </button>
          );
        })}
      </div>
      {selectedTab.content}
    </div>
  );
};

export { Tab };
